module.exports = __webpack_public_path__ + "img/priceImg-1.1659f445.png";